



















/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */
import { TYPES } from '@/types'
import { lazyInject } from '@/container'
import { PhotoService } from '@/services/IPhotoService'
import PhotosHelperMixin from '@/mixins/PhotosHelperMixin.vue'

@Component
export default class UserAwards extends mixins(PhotosHelperMixin) {
  @Prop({ type: String, required: true }) userName: string
  @Prop({ type: String, required: true }) userId: string

  @lazyInject(TYPES.PhotoService)
  PhotoService: PhotoService

  photoAwards: any = {}

  get yearsWithSuffix (): number[] {
    return [
      2016,
      2017,
      2018,
      2019,
      2020,
      2021
    ]
  }

  created () {
    void this.PhotoService.getUserAwards(this.userId)
      .then((response: any) => {
        this.photoAwards = response.data
      })
  }

  getSuffix (year: string) {
    return this.yearsWithSuffix.indexOf(parseInt(year, 0)) !== -1 ? '-profile' : ''
  }

  getAwardImage (place: string | number, suffix = '_place', year?: string | number) {
    if (place === 'grand_prize_winner') {
      place = `gp-${year}`
    }

    return this.isNumeric(place) ? ((place < 10) ? `0${place + suffix}` : place + suffix) : place
  }

  getAwardImageUrl (award: string | number, year: string): string {
    return `${this.cloudFrontImgUrl()}/awards${year}${this.getSuffix(year)}/${this.getAwardImage(award, '_place', year)}.png`
  }
}
